import React from "react";
import HeaderBackground from "../components/HeaderBackground";
import { makeStyles, Typography, Grid } from "@material-ui/core";
import StyledButton from "../components/StyledButton";
import HeaderArtwork from "../components/HeaderArtwork";
import TextTransition, { presets } from "react-text-transition";
import HeaderBackgroundPortrait from "../components/HeaderBackgroundPortrait";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles({
  headerBackground: {
    width: "100%",
    height: "auto",
    zIndex: -1,
  },
  header: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    display: "flex",
    flexDirection: "column",
  },
  actionBar: {
    display: "flex",
    alignItems: "center",
    padding: "2vw 4vw",
    height: 54,
    "& img": {
      height: 32,
      margin: "0px 8px",
    },
  },
  push: {
    flexGrow: 1,
  },
  actionBarButton: {
    margin: "0px 4px",
  },
  bottomBar: {
    color: "white",
    justifyContent: "center",
    alignItems: "center",
    padding: "10vw 8vw",
    position: "relative",
    marginTop: 64,
  },
  bottomBarTitle: {
    fontWeight: "900",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
  },
  animatedText: {
    margin: "0px 8px",
  },
  bottomBarTexts: {},
  bottomBarDescription: {
    fontWeight: "200",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    fontSize: 28,
    opacity: 0.95,
    margin: "12px 0px",
  },
  actionButton: {
    padding: "8px 32px",
    fontWeight: "bold",
    fontSize: 16,
    display: "block",
  },
  "@media (max-width: 720px)": {
    actionButton: {
      margin: "0 auto",
    },
    bottomBarTitle: {
      fontSize: 24,
      textAlign: "center",
    },
    bottomBarDescription: {
      fontSize: 24,

      textAlign: "center",
    },
  },
});

export default function Header() {
  const classes = useStyles();
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    const intervalId = setInterval(() => setIndex((index) => index + 1), 5000);
  }, []);
  const matches = useMediaQuery("(max-width:720px)");

  return (
    <section>
      {matches ? (
        <HeaderBackgroundPortrait className={classes.headerBackground} />
      ) : (
        <HeaderBackground />
      )}
      <header className={classes.header}>
        <section className={classes.actionBar}></section>
        <section className={classes.bottomBar}>
          <Grid container>
            <Grid item xs={12} md={6}>
              <section className={classes.bottomBarTexts}>
                <Typography
                  variant="h3"
                  component="h1"
                  className={classes.bottomBarTitle}
                >
                  آموزش آنلاین زبان
                </Typography>
                <Typography
                  component="h2"
                  className={classes.bottomBarDescription}
                >
                  کلاس خصوصی آنلاین با بهترین اساتید
                </Typography>
                <br />
                <br />
                <StyledButton
                  className={classes.actionButton}
                  variant="contained"
                  color="secondary"
                  style={{
                    display: "inline-block",
                    textDecoration: "none",
                    color: "white",
                    ":hover": {
                      backgroundColor: "secondary",
                    },
                  }}
                  id="header-start-learning"
                  href="/find-teachers"
                  component="a"
                  size="large"
                >
                  شروع یادگیری
                </StyledButton>
              </section>
            </Grid>
            <Grid item xs={12} md={6}>
              <HeaderArtwork />
            </Grid>
          </Grid>
        </section>
      </header>
    </section>
  );
}
